import * as actions$1 from './appointments/actions.js';
export { actions$1 as Appointments };

const PAGE_VIEW = 'my-account/datalayer/page-view';
const PROFILE_EDIT_SUCCESS = 'my-account/datalayer/profile-edit-success';
const PROFILE_EDIT_ERROR = 'my-account/datalayer/profile-edit-error';
const PASSWORD_CHANGE_SUCCESS = 'my-account/datalayer/password-change-success';
const PASSWORD_CHANGE_ERROR = 'my-account/datalayer/password-change-error';
const profileEditSuccess = ()=>({
        type: PROFILE_EDIT_SUCCESS
    })
;
const profileEditError = (error)=>({
        type: PROFILE_EDIT_ERROR,
        payload: {
            error
        }
    })
;

export { PAGE_VIEW, PASSWORD_CHANGE_ERROR, PASSWORD_CHANGE_SUCCESS, PROFILE_EDIT_ERROR, PROFILE_EDIT_SUCCESS, profileEditError, profileEditSuccess };
//# sourceMappingURL=actions.js.map
